
import { defineComponent } from "vue";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import VueElementLoading from "vue-element-loading";
import consts from "@/const/const";

function import_script(urls: string[]) {
  return Promise.all(
    urls.map(function (url: string) {
      return new Promise(function (resolve) {
        const script = document.createElement("script");
        script.src = url;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    })
  );
}

function import_link() {
  const link = document.createElement("link");
  link.rel = "canonical";
  link.href = consts.yumenaviinfo + "vue/howto.html";
  document.head.appendChild(link);
}

export default defineComponent({
  name: "Gakumon",
  components: {
    AppHeader,
    AppFooter,
    VueElementLoading,
  },
  setup() {
    const thisYear = new Date().getFullYear();
    return {
      thisYear,
    };
  },
  data() {
    return {
      consts: consts,
    };
  },
  mounted() {
    import_link();
    import_script([
      "https://code.createjs.com/createjs-2015.11.26.min.js",
    ]).then(function () {
      import_script(["./js/howto.js"]);
    });
    import_script([
      "https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js",
    ]).then(function () {
      import_script(["./js/common.js"]);
    });
    import_script(["./js/gatag.js"]);
  },
});
